import React, { useContext, useEffect, useState } from 'react'
import File from 'app/react/components/File'
import TypographyContext from 'app/react/components/typography/TypographyContext'

export default function Font (props) {

  const { selectedOption, texts } = useContext(TypographyContext)
  const [currType, setCurrType] = useState(null)

  const fontNameStyle = {
    fontFamily: props.name + ', "Gilroy", sans-serif'
  }

  const alphabetStyle = {
    fontFamily: props.name + ', "Roboto", sans-serif'
  }

  useEffect(() => {
    setCurrType(null)
    if (props.types.hasOwnProperty(selectedOption)) {
      setCurrType(props.types[selectedOption])
    }
  }, [selectedOption])

  if (props.types.length === 0 || !currType) return

  return (
    <div className="dm-typography__font">
      {props.tagline && (
        <div className="dm-typography__font-tagline">{props.tagline}</div>
      )}
      {props.name && (
        <div className="dm-typography__font-name dm-title" style={fontNameStyle}>{props.name}</div>
      )}
      <div className="dm-typography__font-alphabet" style={alphabetStyle}>{texts.alphabet}</div>
      <div className="dm-typography__font-alphabet-lowercase" style={alphabetStyle}>{texts.alphabet.toLowerCase()}</div>
      <div className="dm-typography__font-file">
        <File
          url={currType.url}
          title={currType.title}
          text={currType.text}
        />
      </div>
    </div>
  )
}
